import html2canvas from "html2canvas";
import React, { useContext, useEffect, useState } from "react";
import Buttoon from "../../common/Buttoon";
import OverlayB from "../../common/OverlayB";
import * as jsPDF from "jspdf";
import { Store } from "../../state/state";
import { toJS } from "mobx";
import drawCalacateHijri from "../../function/drawCalacateHijri";
import {
  exportComponentAsJPEG,
  exportComponentAsPNG,
} from "react-component-export-image";

const typeDownload = {
  SINGLE: "single",
  ALL: "all",
};
const typeDownloads = [
  { value: typeDownload.SINGLE, label: "الصفحة الحالية فقط" },
  { value: typeDownload.ALL, label: "كل الصفحات" },
];
const TYPE_FILE = {
  PDF: "PDF",
  PNG: "PNG",
  JPG: "JPG",
};
function OverlayDownload({ onClose }) {
  const store = useContext(Store);
  const width = "400px";
  const [isAll, setisAll] = useState(true);
  const [nameFile, setNameFile] = useState("تقويم جديد");
  const [typeFile, setTypeFile] = useState(TYPE_FILE.PDF);
  const [loading, setLoading] = useState(false);
  // useEffect(() => {
  //   console.log("apply");
  //   // setAnimation(!animation);

  //   // setAnimationClass("");
  //   store.cols = drawCalacateHijri(store.calenderRuslt[store.indexTemp]);
  // }, [store.indexTemp]);
  const onSaveOne = async () => {
    // exportComponentAsPDF(ref);
    // exportComponentAsPDF;
    console.log("print one");
    const calender = await document.querySelector("#calender");

    // setLoadingOne(true);
    // console.log("before :", ref.current);
    let canvas = await html2canvas(calender, {
      useCORS: true,
      backgroundColor: null,
      allowTaint: true,
    });
    // console.log("result svg :", canvas);

    const imgData = await canvas.toDataURL("image/jpeg");
    // console.log(imgData);
    const pdf = new jsPDF.jsPDF({
      orientation: "landscape",
    });
    // const pdf = new jsPDF.jsPDF("p", "pt", "a4");
    // var pdf = new jsPDF("p", "pt", "a4");
    const pdfWidth = pdf.internal.pageSize.getWidth();
    const pdfHeight = pdf.internal.pageSize.getHeight();
    console.log(calender);

    let options = {
      // pagesplit: true,
      width: pdfWidth,
      height: pdfHeight,
    };
    var specialElementHandlers = {
      "#elementH": function (element, renderer) {
        return true;
      },
    };
    // console.log("html :", calender.outerHTML);
    // console.log("canvas : ", canvas);
    // console.log({ pdfHeight, pdfWidth });

    await pdf.addImage(imgData, "jpeg", 0, 0, pdfWidth, pdfHeight);
    // await pdf.fromHTML(ref.current, 15, 15, { width: 180, height: 100 });
    // await pdf.html(calender, options);
    // await pdf.addHTML(ref.current);
    // await pdf.addHTML(calender, () => {}).save("download.pdf");
    console.log("file downloading ....");
    await pdf.save(nameFile + ".pdf");
    console.log("done");
    // setLoadingOne(false);
    setLoading(false);
  };
  const onSaveAll = async () => {
    try {
      console.log("print all");
      store.indexTemp = 0;
      const calender = document.querySelector("#calender");
      let canvas = await html2canvas(calender, { useCORS: true });
      console.log("jsx :", calender);
      // await setCols(drawCalacateHijri(store.calenderRuslt[select]));

      const imgData = await canvas.toDataURL("image/png");

      const pdf = new jsPDF.jsPDF({
        orientation: "landscape",
      });
      const pdfWidth = pdf.internal.pageSize.getWidth();
      const pdfHeight = pdf.internal.pageSize.getHeight();
      let index = store.indexTemp;
      await pdf.addImage(imgData, "PNG", 0, 0, pdfWidth, pdfHeight);
      while (store.indexTemp < 11) {
        const calender = document.querySelector("#calender");
        console.log(
          "start=================month(" +
            store.calenderRuslt[index].monthName +
            ")"
        );
        console.log(toJS(store.calenderRuslt[index]));
        // setRef(document.querySelector("calender"));
        console.log("jsx :", toJS(store.calenderRuslt[store.indexTemp]));

        await pdf.addPage();
        ++store.indexTemp;

        // store.cols = drawCalacateHijri(store.calenderRuslt[select]);
        // store.cols = await drawCalacateHijri(store.calenderRuslt[select]);
        let canvas = await html2canvas(calender, { useCORS: true });
        const imgData = await canvas.toDataURL("image/png");
        // console.log("current page : ", toJS(store.calenderRuslt[select]));
        await pdf.addImage(imgData, "PNG", 0, 0, pdfWidth, pdfHeight);
      }
      await pdf.save(nameFile + ".pdf");
    } catch (error) {
      console.log("ERRRO ", error);
    } finally {
      setLoading(false);
    }
  };
  const onSave = async () => {
    const calender = document.querySelector("#calender");

    setLoading(true);
    if (typeFile === TYPE_FILE.PNG) {
      let canvas = await html2canvas(calender, { useCORS: true });
      const imgData = await canvas.toDataURL("image/png");
      console.log(imgData);
      downloadFile(nameFile, "png", imgData);
      setLoading(false);
    } else if (typeFile === TYPE_FILE.JPG) {
      let canvas = await html2canvas(calender, { useCORS: true });
      const imgData = await canvas.toDataURL("image/jpg");
      console.log(imgData);
      downloadFile(nameFile, "jpg", imgData);
      setLoading(false);
    } else if (typeFile === TYPE_FILE.PDF)
      if (!isAll) await onSaveOne();
      else await onSaveAll();
  };
  return (
    <div className="relative" style={{ width: "25vw", height: "60vh" }}>
      <div
        onClick={() => onClose()}
        style={{ right: "0px", top: "0px" }}
        className="bg-red-500 rounded text-white h-8
         cursor-pointer hover:bg-red-600 w-8 flex
         justify-center items-center absolute right-0"
      >
        <span className="fa fa-times"></span>
      </div>
      <div
        className="h-full w-full text-white px-10 flex flex-col py-5 bg-primary "
        style={{ borderRadius: "10px" }}
      >
        <div className="flex-1  justify-center py-24">
          <div className="flex  items-center mb-5 w-full px-8">
            <select
              value={typeFile}
              onChange={(e) => setTypeFile(e.target.value)}
              className=" rounded-r  flex-1 py-2 pr-5 pl-32 text-black  shadow"
              style={{ width: "1500px" }}
            >
              <option>PDF</option>
              <option>PNG</option>
              <option>JPG</option>
            </select>
            <div className="w-24 text-right " style={{ width: "450px" }}>
              <label className="">صيغة الملف</label>
            </div>
          </div>

          <div className="flex  items-center mb-5 w-full px-8">
            <input
              type="text"
              value={nameFile}
              onChange={(E) => setNameFile(E.target.value)}
              className="flex-1 rounded-r text-right text-black py-2 px-5  shadow"
              // style={{ maxWidth: "500px" }}
            />
            <div className="w-24 text-right" style={{ width: "450px" }}>
              <label className="">اسم الملف</label>
            </div>
          </div>
          {typeFile === TYPE_FILE.PDF && (
            <div className="flex  items-center mb-5 w-full px-8">
              <div
                onChange={(e) => setisAll(true)}
                className="w-24 flex items-center"
                style={{ width: "450px" }}
              >
                <label className="">كل الصفحات</label>
                <input type="radio" checked={isAll} name={"isAll"} />
              </div>
              <div
                className="w-24 "
                onChange={(e) => setisAll(false)}
                style={{ width: "450px" }}
              >
                <label className="">الصفحة الحالية فقط</label>
                <input type="radio" checked={!isAll} name={"isAll"} />
              </div>
            </div>
          )}
        </div>
        <div className="flex items-center justify-center px-5 py-2 flex-row-reverse">
          <Buttoon onClick={onSave}>
            تنزيل{" "}
            {loading && (
              <span className="fas fa-circle-notch fa-spin ml-5"></span>
            )}
          </Buttoon>
        </div>
      </div>
    </div>
  );
}
const downloadFile = (fileName, fileType, data) => {
  const element = document.createElement("a");

  element.href = data;

  element.download = `${fileName}.${fileType}`;
  document.body.appendChild(element); // Required for this to work in FireFox
  element.click();
};
export default OverlayB(OverlayDownload);
